import { NgOptimizedImage } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
} from '@angular/core';
import { NgIcon } from '@ng-icons/core';
import type { Maybe } from '@quipex/core/primitives';
import type { ResolvedProblemDetails } from '@quipex/core/utils';
import { HERO_ICONS, QpxBody, QpxModalTitle, QpxIcon } from '../../directives';
import type {
    DataStateImage,
    DataStateLayout,
    DataStateVisualSize,
} from './models';

@Component({
    selector: 'qpx-error-state',
    imports: [NgIcon, QpxIcon, QpxModalTitle, QpxBody, NgOptimizedImage],
    templateUrl: './error-state.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'qpx-error-state',
        '[class.inline]': 'layout() === "inline"',
        '[class.stacked]': 'layout() === "stacked"',
        '[class.hero]': 'visualSize() === "hero"',
        '[class.icon]': 'visualSize() === "icon"',
    },
})
export class ErrorState {
    //#region Inputs
    public readonly heading = input('Unable to load');
    public readonly description = input<string>();
    public readonly error = input<Maybe<ResolvedProblemDetails>>(null);
    public readonly image = input<DataStateImage | null>(null);
    public readonly layout = input<DataStateLayout>('stacked');
    public readonly visualSize = input<DataStateVisualSize>('icon');
    public readonly icon = input('lucideCircleAlert');
    //#endregion

    //#region State
    protected readonly visualImage = computed(() => {
        const image = this.image();

        if (image) {
            return image;
        }

        if (this.visualSize() === 'hero') {
            return HERO_ICONS.barrier.md;
        }

        return null;
    });
    //#endregion
}
